<template>
	<div class="aboutBox">
		<div class="banner">
			<div class="txt">ABOUT US<br>关于我们</div>
			<div class="name">{{tagList.subtitle}}</div>
			<div class="des">{{tagList.content}}</div>
		</div>
		<div class="tagBox">
			<ul class="list flexBox">
				<li v-for="item in tagList.banners">
					<div class="item">
						<p class="name">{{item.title}}</p>
						<i class="line"></i>
						<div class="box">
							<div class="des">{{item.content}}</div>
							<img :src="item.iconUrl" class="icon">
						</div>
					</div>
				</li>
			</ul>
		</div>
		
		<div class="infoBox">
			<div class="hope">
				<div class="box">
					<div class="swiper" id="hopeSwiper">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="item in hopeList.banners">
								<img :src="item.imageUrl">
							</div>
						</div>
						<div class="swiper-pagination"></div>
						<!-- 自定义按钮 -->
						<div class="swiperNext hope-swiper-next">
							<a-icon type="arrow-right" class="icon" />
						</div>
						<div class="swiperPrev hope-swiper-prev">
							<a-icon type="arrow-left" class="icon" />
						</div>
					</div>
					<div class="item">
						<img src="../../../assets/img/about/icon_1.png" class="icon">
						<p class="txt" v-html="hopeList.subtitle" style="white-space: pre-wrap;"></p>
						<p class="name">{{hopeList.categoryName}}</p>
						<p class="des" v-html="hopeList.content" style="white-space: pre-wrap;"></p>
					</div>
				</div>
			</div>
			<div class="aim">
				<div class="box">
					<div class="swiper" id="aimSwiper">
						<div class="swiper-wrapper">
							<div class="swiper-slide" v-for="item in aimList.banners">
								<img :src="item.imageUrl">
							</div>
						</div>
						<div class="swiper-pagination"></div>
						<!-- 自定义按钮 -->
						<div class="swiperNext aim-swiper-next">
							<a-icon type="arrow-right" class="icon" />
						</div>
						<div class="swiperPrev aim-swiper-prev">
							<a-icon type="arrow-left" class="icon" />
						</div>
					</div>
					<div class="item">
						<img src="../../../assets/img/about/icon_1.png" class="icon">
						<p class="txt" v-html="aimList.subtitle" style="white-space: pre-wrap;"></p>
						<p class="name">{{aimList.categoryName}}</p>
						<p class="des" v-html="aimList.content" style="white-space: pre-wrap;"></p>
					</div>
				</div>
			</div>
		</div>
		<div class="cultureBox">
			<div class="name">{{cultureList.subtitle}}</div>
			<div class="tip">{{cultureList.categoryName}}</div>
			<ul class="list flexBox">
				<li v-for="item in cultureList.banners">
					<img :src="item.iconUrl" class="icon">
					<p class="txt">{{item.title}}</p>
					<p class="des" v-html="item.content" style="white-space: pre-wrap;"></p>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import Swiper, {
		Autoplay,
		Grid,
		Navigation,
		Pagination
	} from 'swiper';
	Swiper.use([Autoplay, Grid, Navigation, Pagination]);
	export default {
		name: 'About',
		components: {
	
		},
		data() {
			return {
				tagList:[],
				hopeList:[],
				aimList:[],
				cultureList:[]
			}
		},
		mounted() {
			this.getData()
		},
		methods: {
			getData(){
				this.$req("get","/api/cms/bannerCategory/getByCode/about_info").then((res)=>{
					this.tagList = res.data;
				});		
				this.$req("get","/api/cms/bannerCategory/getByCode/about_qyyj").then((res)=>{
					this.hopeList = res.data;
					this.$nextTick(() => {
						this.updateHope();
					});
				});
				this.$req("get","/api/cms/bannerCategory/getByCode/about_qyzz").then((res)=>{
					this.aimList = res.data;
					this.$nextTick(() => {
						this.updateAim();
					});
				});
				this.$req("get","/api/cms/bannerCategory/getByCode/about_qywh").then((res)=>{
					this.cultureList = res.data;
				});
			},
			updateHope() {
				setTimeout(() => {
					const hopeSwiper = new Swiper('#hopeSwiper', {
						slidesPerView: 2,
						loop: true,
						pagination: {
							el: '#hopeSwiper .swiper-pagination',
							clickable: true,
						},
						navigation: {
							nextEl: '.hope-swiper-next',
							prevEl: '.hope-swiper-prev',
						},
					});
				}, 100);
			},
			updateAim() {
				setTimeout(() => {
					const aimSwiper = new Swiper('#aimSwiper', {
						slidesPerView: 2,
						loop: true,
						pagination: {
							el: '#aimSwiper .swiper-pagination',
							clickable: true,
						},
						navigation: {
							nextEl: '.aim-swiper-next',
							prevEl: '.aim-swiper-prev',
						},
					});
				}, 100);
			},
		}
	}
</script>

<style scoped>
	@import url("../../../assets/css/portal/about.css");
</style>